import blusa1 from './img/products/blusa-1.png';
import blusa2 from './img/products/blusa-2.png';
import blusa3 from './img/products/blusa-3.png';
import blusa4 from './img/products/blusa-4.png';
import blusa5 from './img/products/blusa-5.png';
import blusa6 from './img/products/blusa-6.png';
import blusa7 from './img/products/blusa-7.png';
import blusa8 from './img/products/blusa-8.png';
import blusa9 from './img/products/blusa-9.png';
import blusa10 from './img/products/blusa-10.png';
import blusa11 from './img/products/blusa-11.png';
import blusa12 from './img/products/blusa-12.png';
import blusa13 from './img/products/blusa-13.png';
import blusa14 from './img/products/blusa-14.png';
import blusa15 from './img/products/blusa-15.png';
import blusa16 from './img/products/blusa-16.png';
import blusa17 from './img/products/blusa-17.png';
import blusa18 from './img/products/blusa-18.png';
import blusa19 from './img/products/blusa-19.png';
import blusa20 from './img/products/blusa-20.png';
import blusa21 from './img/products/blusa-21.png';
import blusa22 from './img/products/blusa-22.png';
import blusa23 from './img/products/blusa-23.png';
import blusa24 from './img/products/blusa-24.png';
import blusa25 from './img/products/blusa-25.png';
import blusa26 from './img/products/blusa-26.png';
import blusa27 from './img/products/blusa-27.png';
import blusa28 from './img/products/blusa-28.png';

const productsList = [
    {
        id: 1,
        name: 'Camiseta Dinossauro Espacial',
        value: 44.99,
        imageUrl: blusa1,
    },
    {
        id: 2,
        name: 'Camiseta Gato Espacial',
        value: 54.99,
        imageUrl: blusa2,
    },
    {
        id: 3,
        name: 'Camiseta Astronauta Unicornio',
        value: 39.99,
        imageUrl: blusa3,
    },
    {
        id: 4,
        name: 'Camiseta Ônibus Espacial',
        value: 22.99,
        imageUrl: blusa4,
    },
    {
        id: 5,
        name: 'Camiseta Universo Pintura',
        value: 26.99,
        imageUrl: blusa5,
    },
    {
        id: 6,
        name: 'Camiseta Galáxia',
        value: 14.99,
        imageUrl: blusa6,
    },
    {
        id: 7,
        name: 'Camiseta Galáxia e Estrelas',
        value: 11.99,
        imageUrl: blusa7,
    },
    {
        id: 8,
        name: 'Camiseta Astronauta e Planetas',
        value: 19.99,
        imageUrl: blusa8,
    },
    {
        id: 9,
        name: 'Camiseta Espaço',
        value: 14.99,
        imageUrl: blusa9,
    },
    {
        id: 10,
        name: 'Camiseta Céu Estrelado',
        value: 11.99,
        imageUrl: blusa10,
    },
    {
        id: 11,
        name: 'Camiseta Nasa',
        value: 9.99,
        imageUrl: blusa11,
    },
    {
        id: 12,
        name: 'Camiseta Gato Astronauta',
        value: 49.99,
        imageUrl: blusa12,
    },
    {
        id: 13,
        name: 'Camiseta Olho Do Universo',
        value: 14.99,
        imageUrl: blusa13,
    },
    {
        id: 14,
        name: 'Camiseta Universo',
        value: 14.99,
        imageUrl: blusa14,
    },
    {
        id: 15,
        name: 'Camiseta Gato Cósmico',
        value: 39.99,
        imageUrl: blusa15,
    },
    {
        id: 16,
        name: 'Camiseta Laika',
        value: 49.99,
        imageUrl: blusa16,
    },
    {
        id: 17,
        name: 'Camisetas Balões Espaciais',
        value: 19.99,
        imageUrl: blusa17,
    },
    {
        id: 18,
        name: 'Camiseta Foguete Espacial',
        value: 29.99,
        imageUrl: blusa18,
    },
    {
        id: 19,
        name: 'Espaço Astronauta',
        value: 11.99,
        imageUrl: blusa19,
    },
    {
        id: 20,
        name: 'Camiseta Ets',
        value: 29.99,
        imageUrl: blusa20,
    },
    {
        id: 21,
        name: 'Camiseta Nave Espacial',
        value: 39.99,
        imageUrl: blusa21,
    },
    {
        id: 22,
        name: 'Camiseta Gato Abduzido',
        value: 59.99,
        imageUrl: blusa22,
    },
    {
        id: 23,
        name: 'Camiseta Espacial Gary',
        value: 29.99,
        imageUrl: blusa23,
    },
    {
        id: 24,
        name: 'Camiseta Espaço Final',
        value: 19.99,
        imageUrl: blusa24,
    },
    {
        id: 25,
        name: 'Camiseta Ovnis Nave',
        value: 29.99,
        imageUrl: blusa25,
    },
    {
        id: 26,
        name: 'Camiseta Pintura Espacial',
        value: 12.99,
        imageUrl: blusa26,
    },
    {
        id: 27,
        name: 'Camiseta Cacto Abduzido',
        value: 29.99,
        imageUrl: blusa27,
    },
    {
        id: 28,
        name: 'Camiseta Astronauta',
        value: 11.99,
        imageUrl: blusa28,
    },
];

export default productsList;
